import { useCallback } from 'react';
import { notification, NotificationType } from '@routific/hive';
import { useTranslation } from 'react-i18next';
import { useStore } from '../store/mst';

const getErrorMessage = (error: unknown): string | undefined => {
  const { response } = error as { response?: { errors?: { message: string }[] } };
  return response?.errors?.[0]?.message;
};

const useDeleteRoute = () => {
  const store = useStore();
  const { t } = useTranslation('components');
  const { ui, model, schedulingWorkflow } = store;

  return useCallback(
    async (routeUuids: string[]) => {
      if (!ui.selectedWorkspace?.id) return;

      try {
        await model.deleteRoutes(routeUuids);

        ui.deleteSelectedRoutes();
        if (ui.selectedRoutesBulk.size > 0) {
          ui.clearSelectedRoutesBulk();
        }

        if (schedulingWorkflow.isSchedulingSelectedVisits) {
          const remaining = schedulingWorkflow.selectedRouteUuidsArray.filter(
            (uuid) => !routeUuids.includes(uuid),
          );
          schedulingWorkflow.setSelectedRouteUuids(remaining);
        }
      } catch (error: unknown) {
        notification({
          type: NotificationType.ERROR,
          id: `${ui.selectedWorkspace.id}-delete-failed`,
          message: t('notifications:deleteRoute.failure.message', { message: getErrorMessage(error) }),
          dataCy: 'checkbox-delete-routes-fail-notification',
        });
      }
    },
    [ui, model, schedulingWorkflow, t],
  );
};

export default useDeleteRoute;
